import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';
import { GlobalService } from 'src/app/services/global.service';
import { LicenseService } from 'src/app/services/license-selfie.service';
import { RejectedReasonComponent } from '../../rejected-reason/rejected-reason.component';
import { DocumentsService } from 'src/app/services/documents.service';
import { ImageService } from 'src/app/services/image-service.service';

@Component({
  selector: 'app-vehicle-rent-detail',
  templateUrl: './vehicle-rent-detail.component.html',
  styleUrls: ['./vehicle-rent-detail.component.css']
})
export class VehicleRentDetailComponent implements OnInit {
  openedLicense: any = {};
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private licenseService: LicenseService,
    private _sanitizer: DomSanitizer, 
    private _snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<VehicleRentDetailComponent>,
    private dialog:MatDialog,
    private globalService: GlobalService,
    private documentService: DocumentsService,
    private imageService: ImageService

    ) { }

  ngOnInit(): void {
    this.openedLicense = this.data;
  }


  panelReject(id:number) {
    const dialogRef = this.dialog.open(RejectedReasonComponent, {
      minWidth: '250px',
      data: "DriverLicense"
    });
    dialogRef.afterClosed().subscribe((result:any) => {
      if(result) {
        this.licenseService.setVehicleRentLicenseRejected(id,result.rejectedId).subscribe((data) => {
          this._snackBar.open('Licanse Rejected.', 'Ok', {
            horizontalPosition: 'right',
            verticalPosition: 'bottom',
            duration: 5000,
          });
          this.dialogRef.close("");
        }, this.globalService.handleError);
      }
    });

  }

  panelAccept(id:number) {
    this.licenseService.setVehicleRentLicenseApproved(id).subscribe((data) => {
      this._snackBar.open('Licanse Approved.', 'Ok', {
        horizontalPosition: 'right',
        verticalPosition: 'bottom',
        duration: 5000,
      });
      this.dialogRef.close("");
    }, this.globalService.handleError);
  }

  showImage(image:string) {
    const dialogRef = this.dialog.open(OpenImage, {
      width: '80%',
      maxHeight: '95vh',
      data: image
    });
  }


}


@Component({
  selector: 'open-image',
  template: '<img [src]="data" style="width:100%" >',
})
export class OpenImage {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }
}